import EditorAbstractField from "./EditorAbstractField.mjs";

const EditorEmptyField = class extends EditorAbstractField {
	isValid() {
		const v = this.preFilterValue();
		return !! (v.header || v.footer);
	}
	field() {
		return '';
	}
}

export default EditorEmptyField;